export const filterSpecifications = (specifications, departmentId, divisionId) => {
    if (!specifications)
        return [];

    if (departmentId) 
        specifications = specifications.filter(_ => _.departmentId == departmentId);
    if (divisionId) 
        specifications = specifications.filter(_ => _.divisionId == divisionId);

    return specifications;
}